import { NgClass } from '@angular/common';
import {
  Component,
  computed,
  input,
  model,
  Signal,
  output,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CustomerNavLink } from '../header/header.component';
import { CurrentUser } from 'src/app/interfaces/current-user';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { LoginModalService } from 'src/app/services/LoginModal/login-modal.service';

@Component({
  selector: 'customer-sidebar',
  imports: [NgClass, RouterLink, RouterLinkActive],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  //DATA
  links = input.required<CustomerNavLink[]>();
  user = input.required<CurrentUser | null>();
  cartLength = input<number>();
  username: Signal<string>;
  onLogout = output<void>();
  //UI
  collapsed = model<boolean>(false);

  isLogged: Signal<boolean>;

  constructor(auth: AuthService, private loginModal: LoginModalService) {
    this.isLogged = auth.getAuthState();
    this.username = computed(() => this.getUsername());
  }

  login() {
    this.loginModal.getInstance().onShow();
  }

  logout() {
    this.onLogout.emit();
  }

  getUsername() {
    return this.user()?.first_name != null || this.user()?.last_name != null
      ? `${this.user()?.first_name} ${this.user()?.last_name}`
      : '';
  }
}
